window.addEventListener('DOMContentLoaded', () =>{

    let items = [];
    let images = document.querySelectorAll('body.single-product .product-content img');
    let videos = document.querySelectorAll('body.single-product .product-content video');

    if( images ){
        let imagesArray = Array.from(images);
        items = [ ...items, ...imagesArray ];
    }
    
    if( videos ){
        let videoArray = Array.from(videos);
        items = [ ...items, ...videoArray ];
    }

    if( items  ){
        update_media_urls(items);
    }

    // Changes the domain from website domain to S3 bucket domain
    // Reason: WooMultistore plugin doesn't seem to work with WP Offload Media when the images are removed from server
    function update_media_urls(items){

        let productImage = document.querySelector('.woocommerce-product-gallery__wrapper img');

        if( productImage ){

            const s3Domain = productImage.src.split('/wp-content/')[0]; // ex: http://cdn-s3-verbatimhk.s3.ap-east-1.amazonaws.com

            Array.from(items).forEach( media => {
            
                let src = media.src;
                let baseSrc = src.split('/wp-content/');

                // if image served from server -> change to s3 bucket
                if( baseSrc[0] != s3Domain ){
                    media.src = s3Domain + '/wp-content/' + baseSrc[1];
                }

                if( 'IMG' == media.tagName ){
                    // If srcset urls comes from server -> link to bucket
                    let srcset = media.srcset;
        
                    if( srcset ){
                        let newSrcSet = [];
                        srcset = srcset.split(',');
        
                        srcset.forEach( link => {
        
                            let url = link.split('/wp-content/');
        
                            if( url[0] != s3Domain ){
                                url[0] = s3Domain;
                            }
        
                            newSrcSet.push(url[0] + '/wp-content/' + url[1]);
        
                        } )
        
                        media.srcset = newSrcSet.join(',');
                    }
                }
                
            })
            
        }
    }

});